import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Purpose from './components/Purpose';
import Benefits from './components/Benefits';
import Partnership from './components/Partnership';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Purpose />
        <Benefits />
        <Partnership />
      </main>
      <Footer />
    </div>
  );
}